import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LegacyVaultFAQ: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const { t } = useTranslation();

    const faqItems = [
        {
            title: t('lv_page.faq.is_this_a_will_or_trust'),
            content: t('lv_page.faq.no_we_provide'),
        },
        {
            title: t('lv_page.faq.how_is_this_better'),
            content: t('lv_page.faq.password_managers_die'),
        },
        {
            title: t('lv_page.faq.what_if_my_family'),
            content: t('lv_page.faq.includes_emergency_wallet_cards'),
        },
    ];

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="legacy-vault-faq" className="py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] grid-cols-3 gap-4 px-4 lg:grid">
                <img loading="lazy" src="/assets/images/faq-bg-shape.svg" alt="Faq bg shape" className="absolute -left-60 top-0 lg:-left-96 lg:top-72" />

                <div className="mb-4 inline-block w-full text-center lg:mb-0 lg:pe-12 lg:ltr:text-left lg:rtl:text-right">
                    <h2 className="mb-5 text-[26px]/7 font-bold text-green-700 dark:text-white">{t('lv_page.faq.frequently_asked_questions')}</h2>
                    <p className="text-xl">{t('lv_page.faq.everything_you_need_to_know')}</p>
                </div>

                <div className="col-span-2 mt-10 lg:mt-0">
                    <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                        {faqItems.map((item, index) => (
                            <div key={index} className="border-b-2 border-green-300 bg-transparent dark:border-green-900">
                                <button className="flex w-full items-center justify-between py-4 text-left text-lg font-semibold text-green-700 dark:text-white" onClick={() => toggleAccordion(index)}>
                                    {item.title}
                                    <span className="ml-2 text-green-500">{openIndex === index ? '−' : '+'}</span>
                                </button>
                                {openIndex === index && <div className="pb-4 text-gray-600 dark:text-gray-300">{item.content}</div>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultFAQ;
